import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useIsUserLoggedIn } from 'components/user/UserProvider';
import React from 'react';
import { NavLink as RouterLink, NavLinkProps as RouterLinkProps } from 'react-router-dom';
import LoginButton from '../LoginButton';

const useStyles = makeStyles((theme) => ({
  nav: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    listStyleType: 'none',
    paddingLeft: 0,
  },
  navItem: {
    fontWeight: 500,
    '& + $navItem': {
      paddingLeft: 40,
    },
  },
  navLink: {
    color: theme.palette.secondary.main,
  },
  selected: {
    color: theme.palette.primary.main,
  },
}));

const DesktopMenu: React.SFC<{}> = () => {
  const isLoggedIn = useIsUserLoggedIn();

  const classes = useStyles({});
  const navLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => (
    <RouterLink innerRef={ref} activeClassName={classes.selected} exact {...props} />
  ));

  return (
    <ul className={classes.nav}>
      <Typography component="li" variant="body1" className={classes.navItem}>
        <Button component={navLink} to="/" className={classes.navLink} variant="text">
          Browse Lessons
        </Button>
      </Typography>
      <Typography component="li" variant="body1" className={classes.navItem}>
        <Button component={navLink} to="/submit" className={classes.navLink} variant="text">
          Submit Lesson
        </Button>
      </Typography>
      <Typography component="li" variant="body1" className={classes.navItem}>
        <Button component={navLink} to="/about" className={classes.navLink} variant="text">
          About Us
        </Button>
      </Typography>
      <Typography component="li" variant="body1" className={classes.navItem}>
        <LoginButton />
      </Typography>
      {!isLoggedIn && (
        <Typography component="li" variant="body1" className={classes.navItem}>
          <Button component={navLink} to="/signup" className={classes.navLink} variant="text">
            Signup
          </Button>
        </Typography>
      )}
    </ul>
  );
};

export default DesktopMenu;
